import { useState } from 'react'

export default function Training() {
  const [courses, setCourses] = useState([
    { id: 1, title: 'CMS后台使用教程', type: '系统培训', duration: '45分钟', students: 56, status: 'published' },
    { id: 2, title: 'AI创作营讲师培训', type: '师资培训', duration: '120分钟', students: 23, status: 'published' },
    { id: 3, title: '视频制作技能培训', duration: '90分钟', students: 0, status: 'draft' },
  ])

  const getStatusBadge = (status) => {
    const map = { published: { bg: '#f6ffed', color: '#999', text: '已发布' }, draft: { bg: '#fffbe6', color: '#999', text: '草稿' } }
    const s = map[status] || map.draft
    return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: s.bg, color: s.color }}>{s.text}</span>
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
        <div>
          <h2 style={{ fontSize: 20, marginBottom: 4 }}>📚 培训管理</h2>
          <p style={{ color: '#666', fontSize: 13 }}>管理培训课程和师资培训内?</p>
        </div>
        <button style={{ padding: '12px 24px', background: '#fff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
          + 创建培训课程
        </button>
      </div>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>课程总数</div><div style={{ fontSize: 28, color: '#1890ff' }}>{courses.length}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>已发?</div><div style={{ fontSize: 28, color: '#52c41a' }}>{courses.filter(c => c.status === 'published').length}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>草稿</div><div style={{ fontSize: 28, color: '#faad14' }}>{courses.filter(c => c.status === 'draft').length}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>学习人次</div><div style={{ fontSize: 28, color: '#722ed1' }}>{courses.reduce((s, c) => s + c.students, 0)}</div></div>
      </div>

      {/* Course List */}
      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={th}>课程名称</th>
              <th style={th}>类型</th>
              <th style={th}>时长</th>
              <th style={th}>学习人数</th>
              <th style={th}>状?</th>
              <th style={th}>操作</th>
            </tr>
          </thead>
          <tbody>
            {courses.map(c => (
              <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={td}>{c.title}</td>
                <td style={td}>{c.type}</td>
                <td style={td}>{c.duration}</td>
                <td style={td}>{c.students}</td>
                <td style={td}>{getStatusBadge(c.status)}</td>
                <td style={td}>
                  <button style={{ ...btn, background: '#1890ff', color: '#666' }}>编辑</button>
                  <button style={{ ...btn, background: '#f5f5f5', color: '#999', marginLeft: 8 }}>查看</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const card = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const th = { padding: 14, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 14, fontSize: 13 }
const btn = { padding: '6px 12px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }
